<template>
  <div>
    <headerPage ref="headerPage"></headerPage>
    <div class="content-box" :class="{ 'content-collapse': collapse }">
      <v-tags></v-tags>
      <div style="width: 100%;height: 3px;"></div><!-- 占位DIV -->
      <div class="content" :style="defaultHeight">
        <!-- 需要缓存的页面 -->
        <keep-alive >
          <router-view v-slot="{ Component }" :key="$route.name" v-if="$route.meta.keepAlive" >
            <transition name="move" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </keep-alive>

        <!-- 不需要缓存的页面 -->
        <router-view v-slot="{ Component }" :key="$route.name" v-if="!$route.meta.keepAlive" >
          <transition name="move" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>

      </div>
    </div>
  </div>
</template>

<script>
import headerPage from './HeaderPage'
import vTags from "../../Tags.vue";
export default {
  name: "index",
  data() {
    return {
      defaultHeight: {
        height: ""
      },
    };
  },
  components: {
    headerPage,
    vTags
  },
  watch: {
  },
  computed: {
    tagsList() {
      return this.$store.state.tagsList.map(item => item.name);
    },
    collapse() {
      return this.$store.state.collapse;
    }
  },
  methods: {
    //定义方法，获取高度减去头尾
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 87 + "px";
    },
  },
  created() {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  }
}
</script>

<style scoped>
  .content{
    background: #efefef;
  }
</style>



// WEBPACK FOOTER //
// src/components/theme/default/index.vue